function getWhatsappTagConfig(
	hasWhatsappUser,
	hasWhatsappValidated,
	hasWhatsappLocked,
) {
	if (hasWhatsappLocked) {
		return { text: "WP Validado (Locked)", color: "green" };
	}

	if (hasWhatsappValidated) {
		return { text: "WP Validado", color: "success" };
	}

	if (hasWhatsappUser && !hasWhatsappValidated) {
		return { text: "WP sin validar", color: "blue" };
	}

	if (hasWhatsappUser) {
		return { text: "Con WP", color: "cyan" };
	}

	return { text: "Sin WP", color: "volcano" };
}

export { getWhatsappTagConfig };
